/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-bill-item.reducer';

export const HospitalBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalBillItemEntity = useAppSelector(state => state.hospitalBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalBillItem.detail.title">HospitalBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.id}</dd>
          <dt>
            <span id="descreption">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.descreption">Descreption</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.descreption}</dd>
          <dt>
            <span id="remainingQty">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.remainingQty">Remaining Qty</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.remainingQty}</dd>
          <dt>
            <span id="rate">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.rate">Rate</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.rate}</dd>
          <dt>
            <span id="discountRate">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.discountRate">Discount Rate</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.discountRate}</dd>
          <dt>
            <span id="marginRate">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.marginRate">Margin Rate</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.marginRate}</dd>
          <dt>
            <span id="netRate">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.netRate">Net Rate</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.netRate}</dd>
          <dt>
            <span id="grossValue">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.grossValue">Gross Value</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.grossValue}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.discount}</dd>
          <dt>
            <span id="tax">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.tax">Tax</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.tax}</dd>
          <dt>
            <span id="netValue">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.netValue">Net Value</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.netValue}</dd>
          <dt>
            <span id="taxPlusNetValue">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.taxPlusNetValue">Tax Plus Net Value</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.taxPlusNetValue}</dd>
          <dt>
            <span id="marginValue">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.marginValue">Margin Value</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.marginValue}</dd>
          <dt>
            <span id="adjustedValue">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.adjustedValue">Adjusted Value</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.adjustedValue}</dd>
          <dt>
            <span id="billType">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.billType">Bill Type</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.billType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {hospitalBillItemEntity.microSec ? (
              <TextFormat value={hospitalBillItemEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {hospitalBillItemEntity.timestampEntry ? (
              <TextFormat value={hospitalBillItemEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {hospitalBillItemEntity.lastUpdated ? (
              <TextFormat value={hospitalBillItemEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.cursor}</dd>
          <dt>
            <span id="miscellaneous">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.miscellaneous">Miscellaneous</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.miscellaneous ? 'true' : 'false'}</dd>
          <dt>
            <span id="multiplier">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.multiplier">Multiplier</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.multiplier}</dd>
          <dt>
            <span id="paymentMethod">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.paymentMethod">Payment Method</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.paymentMethod}</dd>
          <dt>
            <span id="paymentStatus">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.paymentStatus">Payment Status</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.paymentStatus}</dd>
          <dt>
            <span id="roundOffVal">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.roundOffVal">Round Off Val</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.roundOffVal}</dd>
          <dt>
            <span id="chargedItem">
              <Translate contentKey="tinyMedicRestApp.hospitalBillItem.chargedItem">Charged Item</Translate>
            </span>
          </dt>
          <dd>{hospitalBillItemEntity.chargedItem}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalBillItem.bill">Bill</Translate>
          </dt>
          <dd>{hospitalBillItemEntity.bill ? hospitalBillItemEntity.bill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalBillItem.patientCategory">Patient Category</Translate>
          </dt>
          <dd>{hospitalBillItemEntity.patientCategory ? hospitalBillItemEntity.patientCategory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalBillItem.hospitalPayment">Hospital Payment</Translate>
          </dt>
          <dd>{hospitalBillItemEntity.hospitalPayment ? hospitalBillItemEntity.hospitalPayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalBillItem.scheme">Scheme</Translate>
          </dt>
          <dd>{hospitalBillItemEntity.scheme ? hospitalBillItemEntity.scheme.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-bill-item/${hospitalBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalBillItemDetail;
